/**
 * @description
 * Checks if `value` is a `Promise`
 *
 * @example
 * ``` ts
 * async function testAsync() {
 *    await Promise.resolve(1);
 * }
 *
 * function test() {
 *    return 1;
 * }
 * isPromise(testAsync());
 * // => true
 * isPromise(test());
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is a `Promise`, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-promise
 */
export const isPromise = <T>(value): value is Promise<T> => {
  if (value !== null && typeof value === 'object') {
    return value && typeof value.then === 'function';
  }
  return false;
};
